import React, { useState } from 'react';
import "../../iqac.css"
import TopNav from '../../../../../Components/TopNav';
import Navbar from '../../../../../Components/Navbar';
import DropdownNav from '../../../../../Components/DropdownNav';
import Footer from '../../../../../Components/Footer';
import Example from '../../../../../Components/Example';
import ScrollToTop from 'react-scroll-to-top';

const SelfStudyReport = () => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <div>
      <Example />
      <ScrollToTop smooth top="1000" />
      <div className='navbar-area'>
        <div className='ssreport-image'>
          <div className='image-cover'>

          </div>
        </div>

      </div>

      <div className='iqac-details'>
        <div className='iqac-header'>
          <h1>Internal Quality Assurance Cell - (IQAC)</h1>
          <h1 className='iqac-obj-tit'>Self Study Report</h1>
        </div>
      </div>


      <div className='iqac-obj-det'>
        <button onClick={() => setIsOpen(e => !e)}           style={{
            marginTop: "20px",
            backgroundColor: "#0c4da2",
            padding: ".7rem",
            color: "white",
            width: "30%",
            alignItems: "center",
            marginLeft: "5%",
            borderRadius: ".3rem",
            cursor: "pointer",
            textAlign: "left",
          }}>Self Study Report of the IQAC</button>
        {
          isOpen && (
            <div className='ssr-items'>
              <a href='https://thenewcollege.edu.in/pdf/The-New-College-SSR-Report.pdf' target='new'>
                <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
              </a>

              <div>
                <h3>Self Study Report</h3>
                <p>4th CYCLE OF ACCREDITATION</p>
                <p>Submitted To  </p>
                <p>NATIONAL ASSESSMENT AND ACCREDITATION COUNCIL</p>
                <p>BANGALORE August 2022</p>
              </div>

            </div>
          )

        }



      </div>

      <Footer />

    </div>
  );
}

export default SelfStudyReport;
